import ColorPalette from '../../components/styling/ColorPalette';
import MainController from '../../controllers/MainController';

const styles = theme => ({
  root: {
    flex: 1,
    flexGrow: 1,
    // maxWidth: '100%',
    display: 'block',
    textTransform: 'capitalize',
    fontSize: '16px',
    color: ColorPalette.primaryText,
    width: 'calc(100% - 5px)',
    height: MainController.showMobileVersion() ? 90 : 'inherit',
  },
  textColorPrimary: {
    margin: 5,
    height: 72,
    borderRadius: 5,
    color: '#233357',
  },
  textColorPrimarySelected: { backgroundColor: ColorPalette.primary, color: '#ffffff' },
  textColorSecondary: {
    borderRadius: 0,
    height: 90,
  },
  textColorSecondarySelected: {
    padding: MainController.showMobileVersion() ? '5px 2.5px' : 0,
    backgroundColor: '#ffffff',
    color: ColorPalette.primary,
    height: 85,
    boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/routeTabs/RouteTabStyles.js